export default [
    {
        path: '/login',
        name: 'LOGIN'
    },
]